import Alert from '@eduzz/fidc-alert';
import * as React from 'react';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { useStyles } from './styles';

function FIDCAlert() {
  const classes = useStyles();
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  if (!user) return null;

  return <Alert className={classes.root} eduzzId={user.id} userName={user.full_name} application='orbita' />;
}

export { FIDCAlert };
